/**
 * 
 * key
 * 
 */


const key = 'bXlDbGllbnRRY1JlY2hlY2s='

export default key 